import { useAgencyConfiguration } from '@/app/shell/agencyConfiguration';

import { DevNavTabs } from './DevNavTabs';

export function DevAgencyConfigPage() {
  const agencyConfiguration = useAgencyConfiguration();

  return (
    <>
      <DevNavTabs />

      <div className="m-3" style={{ minWidth: 0 }}>
        <h1 className="h4">AgencyConfig</h1>
        <pre
          className="small font-monospace mt-3 mb-0 p-3 bg-body-tertiary rounded"
          style={{
            width: '100%',
            maxWidth: 'calc(100vw - 4rem)',
            boxSizing: 'border-box',
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere',
            overflow: 'auto',
          }}
        >
          {JSON.stringify(agencyConfiguration, null, 2)}
        </pre>
      </div>
    </>
  );
}
